import React from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";
import { listCustomers } from "../../graphql/queries";
import { LIST_VEHICALS_INSPECTIONS, getCustomer } from "../../config/myqueries";
import withStyles from "@material-ui/core/styles/withStyles";
import tableStyle from "../../assets/jss/material-dashboard-react/components/tableStyle.jsx";
import PropTypes from "prop-types";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { Nav, NavItem, NavLink } from "reactstrap";
import Tab from "./tab";
import OpenSelect from "../../components/select/select";
import { spinnerService } from "@chevtek/react-spinners";
import _ from "lodash";

class AdminDueDashBoard extends React.Component {
  state = {
    inspections: [],
    data: [],
    vehicles: [],
    customers: [],
    success: false,
    start: 0,
    end: 10,
    tab_data: "notDue",
    header_tab_data: "dot"
  };
  componentDidMount() {
    this.getCustomers();
    this.setState({ success: true });
  }
  getCustomers = () => {
    spinnerService.show("mySpinner");
    let { client } = this.props;
    client
      .query({
        query: gql(listCustomers),
        fetchPolicy: `network-only`,
        variables: { limit: 1000 }
      })
      .then(async data => {
        await this.setState({ customers: data.data.listCustomers.items });
        this.loadCustomerData(data.data.listCustomers.items[0].id);
        spinnerService.hide("mySpinner");
      })
      .catch(err => {
        spinnerService.hide("mySpinner");
        this.setState({ customers: [] });
      });
  };
  loadCustomerData = id => {
    let { client } = this.props;
    let inputObj;
    if (id === "All") {
      inputObj = {
        query: gql(LIST_VEHICALS_INSPECTIONS),
        fetchPolicy: `network-only`,
        variables: {
          limit: 1000
        }
      };
    } else {
      inputObj = {
        query: gql(getCustomer),
        fetchPolicy: `network-only`,
        variables: {
          id
        }
      };
    }
    client
      .query(inputObj)
      .then(data => {
        if (id === "All") {
          this.setState({
            vehicles: data.data.listVehicles.items
          });
        } else {
          this.setState({
            vehicles: data.data.getCustomer.vehicles.items
          });
        }
      })
      .catch(err => {
        this.setState({ customers: [] });
      });
  };
  selectedCustomer = id => {
    let { data } = this.state;
    if (id !== "All") {
      let inspections = data.filter(item => {
        return item.vehicle.customer.id === id;
      });
      this.setState({ inspections });
    } else {
      this.setState({ inspections: data });
    }
  };
  componentWillReceiveProps(props, preProps) {
    if (props.inspections !== preProps.inspections) {
      let { inspections } = props;
      inspections = inspections.filter(item => {
        return item.vehicle !== null;
      });
      this.setState({ data: inspections, inspections, success: true });
    }
  }
  changePage = i => {
    let start = i * 10 - 10,
      end = i * 10;
    this.setState({ start, end });
  };
  toggleTab = e => {
    let { id } = e.target;
    if (id === "bit" || id === "dot") {
      this.setState({ header_tab_data: id });
    } else this.setState({ tab_data: id });
  };
  tabHeader = () => {
    let { header_tab_data } = this.state;
    return (
      <CardHeader style={{ marginTop: 25 }} color="info">
        <Nav tabs id="header">
          <NavItem>
            <NavLink
              id="dot"
              onClick={this.toggleTab}
              className={header_tab_data === "dot" ? "active" : ""}
            >
              Dot Inspections
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              id="bit"
              className={header_tab_data === "bit" ? "active" : ""}
              onClick={this.toggleTab}
            >
              Bit Inspections
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
    );
  };
  mainDiv = () => {
    let { start, end } = this.state;

    const { classes } = this.props;
    let { tab_data, customers } = this.state;
    if (!this.state.success) return <h2>Loading......</h2>;
    else {
      return (
        <React.Fragment>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>Inspection Detail </h4>
                </CardHeader>
                {this.tabHeader()}
                <CardBody style={{ minHeight: 585 }}>
                  <div style={{ marginBottom: 25 }}>
                    <OpenSelect
                      data={customers}
                      selectedItem={this.loadCustomerData}
                    />
                  </div>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        id="notDue"
                        onClick={this.toggleTab}
                        className={tab_data === "notDue" ? "active" : ""}
                      >
                        Not Due
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        id="due"
                        className={tab_data === "due" ? "active" : ""}
                        onClick={this.toggleTab}
                      >
                        Due
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        id="history"
                        onClick={this.toggleTab}
                        className={tab_data === "history" ? "active" : ""}
                      >
                        History
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Tab
                    changePage={this.changePage}
                    history={this.props.history}
                    header_tab_data={this.state.header_tab_data}
                    active={tab_data}
                    data={this.state.vehicles}
                    start={start}
                    end={end}
                    classes={classes}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </React.Fragment>
      );
    }
  };
  render() {
    return <React.Fragment>{this.mainDiv()}</React.Fragment>;
  }
}
AdminDueDashBoard.defaultProps = {
  tableHeaderColor: "gray"
};

AdminDueDashBoard.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    inspections: state.listInspection.data
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};
export default AdminDueDashBoard = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(tableStyle)(AdminDueDashBoard));



// WEBPACK FOOTER //
// ./src/admin/adminDashboard/dashboard.jsx